import { LOCALES, resolveLang } from '@/i18n'
import { parseUTC } from '@/lib/dates'

function activeLocale(): string {
  return LOCALES[resolveLang()]
}

function toDate(value: string | Date): Date {
  return typeof value === 'string' ? parseUTC(value) : value
}

export function formatDate(value: string | Date, options?: Intl.DateTimeFormatOptions): string {
  return toDate(value).toLocaleDateString(activeLocale(), options)
}

export function formatDateTime(value: string | Date, options?: Intl.DateTimeFormatOptions): string {
  return toDate(value).toLocaleString(activeLocale(), options)
}

export function formatNumber(value: number, options?: Intl.NumberFormatOptions): string {
  return value.toLocaleString(activeLocale(), options)
}
